/**
 * Correlation ID for one HTTP request (sent as `X-Request-Id`, echoed in API errors and logs).
 * `crypto.randomUUID` exists only in secure contexts (HTTPS / localhost); an admin opened over
 * plain HTTP on a LAN address falls back to `getRandomValues`, which is always available.
 */
export function newRequestId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
